import React, { Component } from 'react'
import { Link } from 'react-router-dom'

// Pagination: reprend le fonctionnement de la fonction PHP pagination(), qui est assez près du fonctionnement par défaut de paginate_links() de WordPress. [<] [1ère] ... [2e avant la courante] [Avant la courant] [Courante] [Après la courante] [2e après la courante] ... [Dernière] [>] (les ... peuvent venir après la première et/ou avant la dernière). Chercher le mot "formation sur le site et aller à la page 6 pour un exemple "complet".
class Pagination extends Component {
	constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
	}

	handleChange = event => {
		var href = "";
		if ( event.target.href ) {
			href = event.target.href;
		} else {
			href = event.target.parentElement.href;
		}
		this.props.onChange( "page", parseInt( href.substring( href.lastIndexOf( "?page=" ) + 6 ) ) ); // 6 = longueur de "?page="
		window.scroll( 0, 0 );
  }

	render () {
		if ( this.props.nombrePages > 1 ) {
			var pagination = [];
			const adresse = '?page=';
			if ( this.props.pageCourante > 1 ) {
				let lien = this.props.pageCourante - 1;
				pagination.push( <Link onClick={ this.handleChange } className='prev page-numbers' to={ adresse + lien } key='prev' aria-label='Page précédente'><span>&lt;</span></Link> );
			}
			const padding = 2; // Nombre de pages à afficher avant et après la page courante
			var troisPoints = false;
			for ( let i = 1; i < this.props.nombrePages + 1; i++ ) {
				let ajouterLien = false;
				if ( i === 1 || i === this.props.nombrePages) { // On affiche toujours la première et la dernière page
					ajouterLien = true;
				} else if ( i >= this.props.pageCourante - padding && i < this.props.pageCourante ) { // On affiche les X pages précédents la courante
					ajouterLien = true;
				} else if ( i > this.props.pageCourante && i <= this.props.pageCourante + padding ) { // On affiche les X pages suivants la courante
					ajouterLien = true;
				}
				if ( i === this.props.pageCourante ) { // La page courante n'est pas un lien
					pagination.push( <React.Fragment  key={ i }><span aria-current="page" className="page-numbers current">{ i }</span></React.Fragment> );
				} else if ( true === ajouterLien ) {
					troisPoints = false;
					pagination.push(<Link onClick={ this.handleChange } className='page-numbers' to={adresse + i} key={ i }><span className="visually-hidden">Page </span>{ i }</Link> );
				} else if ( false === troisPoints ) {
					troisPoints = true;
					pagination.push( <span className="page-numbers dots" key={ i } aria-hidden="true" >…</span> );
				}
			}
			if ( this.props.pageCourante !== this.props.nombrePages ) {
				let lien = this.props.pageCourante + 1;
				pagination.push( <Link onClick={ this.handleChange } className='next page-numbers' to={ adresse + lien } key='next' aria-label='Page suivante'><span>&gt;</span></Link> );
			}
		}
		return (
			<div className='pagination-wrapper'>
				<nav aria-label="Pagination" className='pagination'>
					{ pagination }
				</nav>
			</div>
		)
	}
}

export default Pagination
